
<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Centros de Custo</span>
        <button class="action-button ml-2 my-1" (click)="create()">Novo Centro de Custo</button>
    </div>

<!-- <div class="container-fluid">
    <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 text-left"><span class="list-header-title">Centros de Custo</span></div>
        <div class="col-lg-3 col-md-3 col-sm-12 text-left"><button type="button" class="list-header-button"
                (click)="create()"><img class="list-header-icon" src="./assets/icons/user-purple.png" /> NOVO CENTRO DE
                CUSTO</button></div>
    </div>
</div> -->

<div class="component-box container-fluid">
    <!--opções listagem-->
    <div class="row container-fluid pt-4">
        <div class="col-12 text-right">
            <ul class="options-cadastro">
                <li>
                    <div class="list-select mr-4 my-1">
                        <button class="list-select" (click)="selectAllToDelete(selectAll = !selectAll);">Selecionar tudo</button>
                    </div>
                </li>
                <li>
                    <div *ngIf="deleteCount > 0" class="list-select mr-4 my-1">
                        <button class="list-select-delete" (click)="showDeleteAll(deleteallmodal);">Excluir</button>
                    </div>
                </li>
                <li>
                    <div class="list-select mr-4 my-1">
                        <button type="button" class="list-select" (click)="showFilter(filtro)">
                            Aplicar filtro
                        </button>
                    </div>
                </li>
                <li>
                    <div class="list-select-search-input mr-42 my-1">
                        <input class="w-100" type="search" placeholder="Pesquise aqui..." [(ngModel)]="filtroPesquisa" />
                    </div>
                </li>
                <li>
                    <div class="list-filter-show-item ml-2 my-1">Mostrar:
                        <select [(ngModel)]="showItem">
                            <option [ngValue]="10" value="10" selected>10</option>
                            <option [ngValue]="25" value="25">25</option>
                            <option [ngValue]="50" value="50">50</option>
                            <option [ngValue]=100 value="100">100</option>
                        </select>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <div class="table-overflow mx-2">
        <table class="list-table table table-striped">
            <thead class="list-table-head">
                <th></th>
                <th class="" (click)="sortOrder = !sortOrder; orderBy('codigo', sortOrder)">Código</th>
                <th class="" (click)="sortOrder = !sortOrder; orderBy('nome', sortOrder)">Nome</th>
                <th class="" (click)="sortOrder = !sortOrder; orderBy('nomeResponsavel', sortOrder)">Nome do responsável
                </th>
                <th class="" (click)="sortOrder = !sortOrder; orderBy('emailResponsavel', sortOrder)">E-mail do
                    responsável</th>
                <th class="" (click)="sortOrder = !sortOrder; orderBy('status', sortOrder)">Status</th>
                <th></th>
            </thead>
            <tbody class="list-table-row">
                <tr *ngFor="let item of centrosCustosList | paginate: { itemsPerPage: showItem, currentPage: currentPage } | searchFilter: filtroPesquisa | modalFilter: filtroCodigo:filtroNome:filtroNomeResponsavel:filtroEmailResponsavel"
                    class=" list-table-cell">
                    <td class="clickable" (click)="item.toDelete = !item.toDelete; updateDeleteCount();">
                        <span class="mx-2">
                            <input [attr.id]="item.centroCustoId" type="checkbox" class="radio-checkbox"
                                [(ngModel)]="item.toDelete"
                                (click)="item.toDelete = !item.toDelete; updateDeleteCount();" />
                            <label [attr.for]="item.centroCustoId" class="radio-label"></label>
                        </span>
                    </td>
                    <td class="clickable" (click)="item.toDelete = !item.toDelete; updateDeleteCount();">{{item.codigo}}
                    </td>
                    <td class="clickable" (click)="item.toDelete = !item.toDelete; updateDeleteCount();">{{item.nome}}
                    </td>
                    <td class="clickable" (click)="item.toDelete = !item.toDelete; updateDeleteCount();">
                        {{item.nomeResponsavel}}</td>
                    <td class="clickable" (click)="item.toDelete = !item.toDelete; updateDeleteCount();">
                        {{item.emailResponsavel}}</td>
                    <td class="clickable" (click)="item.toDelete = !item.toDelete; updateDeleteCount();">
                        {{Status[item.status]}}</td>
                    <td>
                        <div ngbDropdown class="d-inline-block menu-option">
                            <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle><img
                                    src="assets/icons/menu.png" /></button>
                            <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                <section class="custom-context-menu">
                                    <div ngbDropdownItem (click)="edit(item)"><img src="assets/icons/pencil-purple.png"
                                            class="mr-2" />Editar</div>
                                    <div ngbDropdownItem (click)="showDelete(deletemodal,item);">
                                        <img src="assets/icons/garbage-purple.png" class="mr-2" />Excluir
                                    </div>
                                    <div ngbDropdownItem (click)="showCardholders(modalCardholders,item);">
                                        <img src="assets/icons/user-purple.png" class="mr-2" />Ver Portadores
                                    </div>
                                </section>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="page-custom mt-2">
            <pagination-controls (pageChange)="currentPage = $event" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
        </div>
    </div>
</div>
</div>
<!--Modal do Filtro-->
<ng-template #filtro let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar Filtro</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <mat-form-field class="w-100">
                <mat-label>Código</mat-label>
                <input [formControl]="codeCtrl" matInput type="text" [(ngModel)]="filtroCodigo" id="codigo">
                <button mat-button *ngIf="filtroCodigo" matSuffix mat-icon-button aria-label="Clear" (click)="filtroCodigo=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <mat-form-field class="w-100">
                <mat-label>Nome</mat-label>
                <input [formControl]="nameCtrl" matInput type="text" [(ngModel)]="filtroNome" id="nome">
                <button mat-button *ngIf="filtroNome" matSuffix mat-icon-button aria-label="Clear" (click)="filtroNome=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <mat-form-field class="w-100">
                <mat-label>Nome do responsável</mat-label>
                <input [formControl]="nameManagerCtrl" matInput type="text" [(ngModel)]="filtroNomeResponsavel" id="nomeResponsavel">
                <button mat-button *ngIf="filtroNomeResponsavel" matSuffix mat-icon-button aria-label="Clear" (click)="filtroNomeResponsavel=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <mat-form-field class="w-100">
                <mat-label>E-mail do responsável</mat-label>
                <input [formControl]="emailManagerCtrl" matInput type="text" [(ngModel)]="filtroEmailResponsavel" id="email">
                <button mat-button *ngIf="filtroEmailResponsavel" matSuffix mat-icon-button aria-label="Clear" (click)="filtroEmailResponsavel=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button"
            (click)="applyFilter();modal.dismiss('Close click')" ngbAutofocus>
            Aplicar
        </button>
    </div>
</ng-template>

<!--Modal do Deletar-->
<ng-template #deletemodal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Deletar Centro de Custo</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <p class="col-12 clean-modal-subtitle" style="font-size: 20px;">
            Tem certeza que deseja excluir o centro de custo:
            <span style="color:#313840; font-weight: bold;">{{centroCustoToDelete.nome}}?</span>
        </p>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="delete(centroCustoToDelete);modal.dismiss('Close click')">
            Excluir
        </button>
    </div>
</ng-template>

<!--Modal do Deletar Vários-->
<ng-template #deleteallmodal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Deletar Centros de Custo</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <p class="col-12 clean-modal-subtitle" style="font-size: 20px;">
            Tem certeza que deseja excluir {{deleteCount}} centro(s) de custo(s)?
        </p>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-filter-button custom-filter-button-just" type="button" [disabled]="deleteCount < 1" (click)="deleteAllSelected();modal.dismiss('Close click')">
            Excluir
        </button>
    </div>
</ng-template>


<!-- Modal Ultimos Creditos -->
<ng-template #modalCardholders let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Portadores</h5>
        </div>
    </div>
        <div class="row p-4 d-flex justify-content-end ">
            <div class="col-12">
                <div class="table-overflow">
                    <div class="table-responsive">
                        <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0">
                            <thead>
                                <tr>
                                    <th scope="col">Portador</th>
                                    <th scope="col">Criado</th>
                                    <th scope="col">Final do cartão</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of cardholderList | paginate : { itemsPerPage: 5, currentPage: cardholderPage, id: 'cardholderPagination', totalItems: totalItems }">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.createAt | date: "dd/MM/yy HH:mm" }}</td>
                                    <td>{{ item.FinalCard }}</td>
                                </tr>
                            </tbody>
                        </table>
    
                        <div *ngIf="totalItems === 0" class="text-center">
                            <h6>
                                Nenhum Portador carregado.
                            </h6>
                        </div>
    
                        <div class="page-custom mt-2">
                            <pagination-controls  id="cardholderPagination" (pageChange)="getCardholders($event, colaId)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--div class="col-12 clean-modal-footer">
            <button class="custom-filter-button custom-filter-button-just" type="button" (click)="applyFilter();" ngbAutofocus>
                Aplicar
            </button>
        </div-->
    </ng-template>
